import ITask from '../../../Utility/Task/ITask';
import CardSystem from '../CardSystem';
import { UIEvent } from '../../UI/BaseUISystem';

export class RestoreInteractivityTask implements ITask<CardSystem> {
    * execute(system: CardSystem) {
        system.scene.emit(UIEvent.RESTORE_INTERACTIVITY);
    }
}
